import { render, staticRenderFns } from "./MandateDetails.vue?vue&type=template&id=29591534"
import script from "./MandateDetails.vue?vue&type=script&lang=js"
export * from "./MandateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports